// @ts-check

/**
 * @file Sets the active web document title.
 */

import {memo, useEffect} from "react"
import {Platform} from "react-native"

/** @import {ReactNode} from "react" */

/**
 * @typedef {object} ScreenTitleProps
 * @property {string} children Title for the active screen.
 */

/**
 * Updates `document.title` on web so the browser tab reflects the current screen.
 * @param {ScreenTitleProps} props Component props.
 * @returns {ReactNode} Nothing visible.
 */
function ScreenTitle({children}) {
  useEffect(() => {
    if (Platform.OS !== "web" || typeof document === "undefined") return undefined
    const previous = document.title
    document.title = children
    return () => {
      document.title = previous
    }
  }, [children])
  return null
}

export default memo(ScreenTitle)
